










import {Component, Vue} from 'vue-property-decorator';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
import VeneerProductionEquipmentTypeEditDialog from '@/views/catalogues/equipment/equipmentType/VeneerProductionEquipmentTypeEditDialog.vue';
import VeneerProcessingEquipmentTypeEditDialog from '@/views/catalogues/equipment/equipmentType/VeneerProcessingEquipmentTypeEditDialog.vue';
import PlywoodProductionEquipmentTypeEditDialog from '@/views/catalogues/equipment/equipmentType/PlywoodProductionEquipmentTypeEditDialog.vue';
import PlywoodProductionSupportEquipmentTypeEditDialog from '@/views/catalogues/equipment/equipmentType/PlywoodProductionSupportEquipmentTypeEditDialog.vue';
import PlywoodProcessingEquipmentTypeEditDialog from '@/views/catalogues/equipment/equipmentType/PlywoodProcessingEquipmentTypeEditDialog.vue';
import equipmentCategoryConfig from '@/enums/EquipmentCategoryEnum';

@Component({
    components: {
        PlywoodProductionSupportEquipmentTypeEditDialog,
        PlywoodProductionEquipmentTypeEditDialog,
        VeneerProcessingEquipmentTypeEditDialog,
        VeneerProductionEquipmentTypeEditDialog,
        CFlexGrid,
    },
})
export default class EquipmentType extends Vue {
    get editDialogsConfig() {
        return {
            getId(item: any) {
                if ('IdEquipmentCategory' in item) return item.IdEquipmentCategory;
                return item.id;
            },
            items: [
                {
                    dialogRef: 'veeneerProduction',
                    dialog: VeneerProductionEquipmentTypeEditDialog,
                    urlPath: this.$api.catalogues.veneerProductionEquipmentType,
                    text: this.$t('Enumeration.EquipmentCategoryVeneerProductionEquipment'),
                    id: equipmentCategoryConfig.VeneerProductionEquipment,
                },
                {
                    dialogRef: 'veeneerProcessing',
                    dialog: VeneerProcessingEquipmentTypeEditDialog,
                    urlPath: this.$api.catalogues.veneerProcessingEquipmentType,
                    text: this.$t('Enumeration.EquipmentCategoryVeneerProcessingEquipment'),
                    id: equipmentCategoryConfig.VeneerProcessingEquipment,
                },
                {
                    dialogRef: 'plywoodProduction',
                    dialog: PlywoodProductionEquipmentTypeEditDialog,
                    urlPath: this.$api.catalogues.plywoodProductionEquipmentType,
                    text: this.$t('Enumeration.EquipmentCategoryPlywoodProductionEquipment'),
                    id: equipmentCategoryConfig.PlywoodProductionEquipment,
                },
                {
                    dialogRef: 'plywoodProductionSupport',
                    dialog: PlywoodProductionSupportEquipmentTypeEditDialog,
                    urlPath: this.$api.catalogues.plywoodProductionSupportEquipmentType,
                    text: this.$t('Enumeration.EquipmentCategoryPlywoodProductionSupportEquipment'),
                    id: equipmentCategoryConfig.PlywoodProductionSupportEquipment,
                },
                {
                    dialogRef: 'plywoodProcessing',
                    dialog: PlywoodProcessingEquipmentTypeEditDialog,
                    urlPath: this.$api.catalogues.plywoodProcessingEquipmentType,
                    text: this.$t('Enumeration.EquipmentCategoryPlywoodProcessingEquipment'),
                    id: equipmentCategoryConfig.PlywoodProcessingEquipment,
                },
            ],
        };
    }
}
